module.exports = __webpack_public_path__ + "static/media/Public Stations.11953aec.svg";